export enum BackupRoutesEnum {
  Overview = 'overview',
  Uploads = 'uploads',
  Reports = 'reports',
  Members = 'members',
  Settings = 'settings',
}
